import "./App.css";
import React, { useState, useEffect } from "react";
import Macbook from "./img/macbook_mockup.png";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
// import { useNavigate } from "react-router-dom";
import { Typography, IconButton } from "@mui/material";
import { useHistory } from "react-router-dom";
import { ChevronRight, ExpandMore } from "@mui/icons-material";
import IphoneImage from "./img/iphone_mockup.png";
import verified from "../../../assets/img/verified.png";
import disbursement from "../../../assets/img/disbursement.png";
import mutual_agreement from "../../../assets/img/mutual_agreement.png";
import one from "../../../assets/img/one.png";
import five from "../../../assets/img/newong-01.png";
import six from "../../../assets/img/newong-02.png";
import two from "../../../assets/img/two.png";
import three from "../../../assets/img/three.png";
import four from "../../../assets/img/four.png";
import SgIcon from "./img/197496.png";
import CloseIcon from "@mui/icons-material/Close";
import bank_image from "../../../assets/img/bank_image.png";
import { Modal, Button, message } from "antd";
import tiktokIcon from "./img/tik-tok.png";
import telegramicon from "./img/telegram.png";
import linkedinicon from "./img/linkedin.png";
import whatsappicon from "./img/whatsapp.png";
import HomeHeader from "./Headesr.jsx";

const PrivacyPolicy = () => {
  // const navigate = useHistory();
  const history = useHistory();

  const [screenWidth, setScreenWidth] = useState(1920);
  const [pageLoad, setPageLoad] = useState(false);
  const [screenHeight, setScreenHeight] = useState(1080);
  useEffect(() => {
    setPageLoad(true);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
      setScreenHeight(window.innerHeight);
    };

    // Call handleResize initially to set the initial screen width
    handleResize();

    // Add event listener for resize
    window.addEventListener("resize", handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [privacyBar, setPrivacybar] = useState(true);
  useEffect(() => {
    if (screenWidth > 1200) {
      setPrivacybar(true);
    }
  }, []);

  useEffect(() => {
    if (screenWidth < 1200) {
      setPrivacybar(false);
    }
  }, [screenWidth]);
  return (
    <div style={{ width: "100%", overflowX: "hidden", position: "relative" }}>
      <div
        style={{
          background: "white",
          position: "fixed",
          width: "100%",
          height: "40px",
          display: privacyBar ? "flex" : "none",
          justifyContent: "space-between",
          alignItems: "center",
          zIndex: "49",
          background: "rgb(37, 97, 153)",
        }}
      >
        <div
          style={{
            marginLeft: "20px",
            color: "rgba(0,0,0,0.7)",
            fontSize: "14px",
            color: "white",
          }}
        >
          Information is collected in accordance with our Privacy Policy by
          continuing you agree to our terms.
        </div>
        <CloseIcon
          style={{ marginRight: "20px", cursor: "pointer", color: "white" }}
          onClick={() => setPrivacybar(false)}
        />
      </div>
      {/* Header bar */}
      <div
        style={{
          position: "fixed",
          background: "white",
          display: "flex",
          justifyContent: "center",
          height: "70px",
          boxShadow: "0px 0px 10px rgba(0,0,0,0.2)",
          alignItems: "center",
          width: "100%",
          top: privacyBar ? "40px" : "0px",
          zIndex: "50",
        }}
      >
        <HomeHeader />
      </div>
      <div
        style={{
          padding: "35px 0px",
          textAlign: "center",
          background: "#256199",
          marginLeft: pageLoad ? "0px" : "-300px",
          opacity: pageLoad ? "1" : "0",
          transition: "all 0.8s ease-in-out",
          marginTop: "100px",
        }}
      >
        <div
          style={{
            fontSize: screenWidth > 1200 ? "45px" : "30px",
            fontWeight: "700",
            color: "white",
          }}
        >
          Privacy Policy
        </div>
        {/* <div
          style={{ display: "flex", justifyContent: "center", width: "100%" }}
        >
          <div
            style={{
              fontSize: "15px",
              fontWeight: "400",
              width: screenWidth > 1200 ? "50%" : "80%",
              marginTop: "10px",
              color: "white",
            }}
          >
            Here you will find answers to some of the most commonly asked
            questions about our work management platform, Premelo. If you have
            any additional questions that are not covered here, please do not
            hesitate to contact our support team for further assistance.
          </div>
        </div> */}
      </div>
      <div style={{ width: "80%", marginLeft: "10%", padding: "50px 0px" }}>
        This Data Protection Policy (“Policy”) outlines how SmartLend Financial
        Pte. Ltd. and/or its related corporations and/or affiliates (“we”, “us”,
        or “our”, “SmartLend”) may collect, use, store, disclose or otherwise
        process personal data you may provide to us when you access and use
        Platform and Service. This Policy is an integral part of, and must be
        read with, our Website Terms of Use and all other policies, procedures
        and rules published on this Platform, as may be amended from time to
        time. Unless otherwise stated herein, capitalised words, phrases or
        terms that appear hereinafter shall have the same meanings as they have
        been defined or described in the Website Terms of Use as may be updated
        or amended from time to time.
        <br />
        <br />
        “You” or “Your" means users or persons who access our Platform.
        <br />
        <br />
        The Policy supplements, but does not supersede or replace, any other
        consent that you may have previously provided to us in relation to your
        personal data. It also does not affect any rights that we may have under
        relevant Singapore law, including the Personal Data Protection Act 2012
        and its regulations (collectively, the “PDPA”), in connection with the
        collection, use, and/or disclosure of your personal data.
        <br />
        <br />
        <br />
        <span style={{ fontWeight: 800 }}>Personal Data</span>
        <br />
        <br />
        1. As used in this Policy:
        <br />
        <br />
        “personal data” means data, whether true or not, about an individual who
        can be identified: (a) from that data; or (b) from that data and other
        information to which we have or are likely to have access; "Platform"
        means our platform, and any websites, any mobile application operated by
        us or linked to our platform, or any page thereof; and "Services" means
        such service that we may provide on our Platform.
        <br />
        <br />
        2. Depending on the nature of your interaction with us, some examples of
        personal data which we may collect from you include your name and
        contact information such as your address, email address and telephone
        number.
        <br />
        <br />
        3. Other terms used in this Policy shall have the meanings given to them
        in the PDPA (where the context so permits). Collection, Storage and Use
        & Disclosure of Personal Data
        <br />
        <br />
        4. We may collect personal information that can identify you (including
        but not limited to your name and e-mail address, contact details,
        residential address, gender, age, date of birth and identity
        card/passport details) as well as other information that does not
        identify you (including but not limited to specimen signatures, voice
        recordings of conversations or occupation). When you provide personal
        information through the Platform or otherwise provide to us, the
        information may be sent to servers located in Singapore or such other
        country or territory as may be permitted by law.
        <br />
        <br />
        5. We use various technologies to collect information from you and about
        your activities on our Platform. We automatically collect information
        from your browser when you visit our Platform. This information may
        include your IP address, your browser type and language, access times,
        the content of any undeleted cookies that your browser previously
        accepted from us and the referring website address.
        <br />
        <br />
        6. We or our third party service providers may use standard Internet
        technology, such as web beacons and other similar technologies, to track
        your use on the Platform. We also may include web beacons or similar
        technology in promotional e-mail messages or newsletters to determine
        whether messages have been opened and acted upon. The information we
        obtain in this manner enables us to customise the Services we offer to
        deliver targeted advertisements and to measure the overall effectiveness
        of our online advertising, content, programming or other activities.
        <br />
        <br />
        7. We may collect and use your personal data for any or all of the
        following purposes:
        <br />
        <br />
        (a) performing obligations in the course of or in connection with our
        provision of the goods and/or services requested by you;
        <br />
        <br />
        (b) verifying your identity;
        <br />
        <br />
        (c) responding to, handling, and processing queries, requests,
        applications, complaints, and feedback from you;
        <br />
        <br />
        (d) managing your relationship with us;
        <br />
        <br />
        (e) sending marketing information about our goods or services including
        notifying you of our marketing events and other promotions;
        <br />
        <br />
        (f) complying with any applicable laws, regulations, codes of practice,
        guidelines, or rules, or to assist in law enforcement and investigations
        conducted by any governmental and/or regulatory authority;
        <br />
        <br />
        (g) any other specific purposes for which you have provided the
        information;
        <br />
        <br />
        (h) transmitting to any unaffiliated or affiliated third parties
        including our third party service providers and agents, and relevant
        governmental and/or regulatory authorities, whether in Singapore or
        abroad, for the aforementioned purposes;
        <br />
        <br />
        (i) any other incidental business purposes related to or in connection
        with the above.
        <br />
        <br />
        (j) engaging third party software providers to collect information about
        the use of our websites, such as pages visited, links clicked and
        non-sensitive text entered and mouse movements. This will help us
        understand your needs better and optimize our services.
        <br />
        <br />
        <br />
        8. We may disclose your personal data:
        <br />
        <br />
        (a) where such disclosure is required for performing obligations in the
        course of or in connection with our provision of the goods or services
        requested by you;
        <br />
        <br />
        (b) in connection with a substantial corporate transaction, such as the
        sale of our business, a divestiture, merger, consolidation, asset sale
        or in the unlikely event of bankruptcy;
        <br />
        <br />
        (c) in response to a subpoena or similar investigative demand, a court
        order or a request for cooperation from a law enforcement or other
        government agency; to establish or exercise our legal rights; to defend
        against legal claims; or as otherwise required by law. In such cases, we
        may raise or waive any legal objection or right available to us;
        <br />
        <br />
        (d) when we believe disclosure is appropriate in connection with efforts
        to investigate, prevent or take other action regarding illegal activity,
        suspected fraud or other wrongdoing; to protect and defend the rights,
        property or safety of our company, our users, our employees or others;
        to comply with applicable law or cooperate with law enforcement; to
        comply with the relevant listing rules of the applicable stock exchange;
        or to enforce our Website Terms of Use, or other agreements or policies
        including this Policy; and/or
        <br />
        <br />
        <br />
        9. You agree that we are not responsible for the actions of these third
        parties with respect to their use and handling of your personal data and
        that you shall have no recourse whatsoever against us in respect of
        these third party actions. If you want to learn more about the privacy
        practices of these third parties, you agree that you will do the
        necessary to visit the websites of those third parties or perform such
        further understanding as you may deem necessary. These entities or their
        servers may be located either inside or outside Singapore. We hereby
        expressly exclude any liability as to the inappropriate usage of your
        data by these third party service providers and agents.
        <br />
        <br />
        <br />
        10. The purposes listed in the above clauses may continue to apply even
        in situations where your relationship with us (for example, pursuant to
        a contract) has been terminated or altered in any way, for a reasonable
        period thereafter (including, where applicable, a period to enable us to
        enforce our rights under any contract with you).
        <br />
        <br />
        <br />
        <span style={{ fontWeight: 800 }}>Withdrawing Your Consent</span>
        <br />
        <br />
        11. The consent that you provide for the collection, use and disclosure
        of your personal data will remain valid until such time it is being
        withdrawn by you in writing. You may withdraw consent and request us to
        stop using and/or disclosing your personal data for any or all of the
        purposes listed above by submitting your request in writing or via email
        to support@smart-lend.com.
        <br />
        <br />
        12. Upon receipt of your written request to withdraw your consent, we
        may require reasonable time (depending on the complexity of the request
        and its impact on our relationship with you) for your request to be
        processed and for us to notify you of the consequences of us acceding to
        the same, including any legal consequences which may affect your rights
        and liabilities to us.
        <br />
        <br />
        13. Whilst we respect your decision to withdraw your consent, please
        note that depending on the nature and scope of your request, we may not
        be in a position to continue providing our goods or services to you and
        we shall, in such circumstances, notify you before completing the
        processing of your request. Should you decide to cancel your withdrawal
        of consent, please inform us in writing.
        <br />
        <br />
        14. Please note that withdrawing consent does not affect our right to
        continue to collect, use and disclose personal data where such
        collection, use and disclosure without consent is permitted or required
        under applicable laws.
        <br />
        <br />
        <br />
        <span style={{ fontWeight: 800 }}>Protection of Personal Data</span>
        <br />
        <br />
        15. To safeguard your personal data from unauthorised access,
        collection, use, disclosure, copying, modification, disposal or similar
        risks, we have introduced appropriate administrative, physical and
        technical measures such as up-to-date antivirus protection, encryption
        and the use of privacy filters to secure all storage and transmission of
        personal data by us, and disclosing personal data both internally and to
        our authorised third party service providers and agents only on a
        need-to-know basis.
        <br />
        <br />
        16. You should be aware, however, that no method of transmission over
        the Internet or method of electronic storage is completely secure. While
        security cannot be guaranteed, we strive to protect the security of your
        information and are constantly reviewing and enhancing our information
        security measures. In the event of a data breach, we will notify the
        affected individuals as soon as practicable (no later than 72 hours)
        after establishing that the data breach is likely to result in
        significant harm or impact to the individuals to whom the information
        relates.
        <br />
        <br />
        <br />
        <span style={{ fontWeight: 800 }}>Accuracy of Personal Data.</span>
        <br />
        <br />
        17. Where you provide personal data to us, you shall take reasonable
        effort to ensure that the personal data is accurate and complete before
        providing the same to us. SmartLend shall put in place adequate measures
        to ensure that the personal data in its possession or control remain or
        is otherwise accurate and complete. In any case, SmartLend shall take
        steps to correct any errors in the personal data, as soon as practicable
        upon your written request.
        <br />
        <br />
        <br />
        <span style={{ fontWeight: 800 }}>Retention of Personal Data.</span>
        <br />
        <br />
        18. SmartLend shall, upon your written request: (a) return to the you,
        all personal data; or (b) delete all personal data in its possession,
        and, after returning or deleting all personal data, provide you with
        written confirmation that we no longer possess any personal data. Where
        applicable, SmartLend shall also instruct all third parties to whom it
        has disclosed personal data for the purposes of this Policy to return to
        SmartLend or delete, such personal data.
        <br />
        <br />
        <br />
        <span style={{ fontWeight: 800 }}>Our Use of Cookies</span>
        <br />
        <br />
        19. By using our website with your browser settings adjusted to accept
        cookies you consent to our use of cookies and other tools to provide the
        products and services available on our website.
        <br />
        <br />
        20. Cookies are small text files that may be placed on your web browser
        when you visit our website. Cookies allow your browser to remember some
        specific information which the web server can later retrieve and use. We
        do not use cookies to store any personal information that could be read
        or understood by others.
        <br />
        <br />
        <br />
        <span style={{ fontWeight: 800 }}> Your Rights in Respect of Your
        Personal Data</span>
        <br />
        <br />
        21. Subject to applicable guidelines issued by the Personal Data
        Protection Commission in Singapore on access and correction obligations
        (as may be amended from time to time and if applicable), you have the
        right to access, update or correct the personal data we hold about you
        or withdraw your consent to the use, collection and disclosure of your
        personal data. If you have any questions about this Policy, or if you
        wish to access, update or correct your personal data or withdraw your
        consent to the use, collection and disclosure of your personal data,
        please email support@smart-lend.com. We have the discretion to charge a
        small fee for this service. Please note that if you withdraw consent, we
        may still be permitted to hold, use or disclose some of your information
        as required or permitted by law.
        <br />
        <br />
        <br />
        <span style={{ fontWeight: 800 }}>Effect of Policy and Changes to
        Policy</span>
        <br />
        <br />
        22. This Policy is intended to cover collection of information on the
        Platform from persons in Singapore. If you are using the Platform from
        outside Singapore, please be aware that your information may be
        transferred to, stored and processed in Singapore (or such other country
        or territory as may be permitted) where our servers are located and our
        central database is operated. The data protection and other laws of
        Singapore and other countries might not be as comprehensive as those in
        your country. Please be assured that we seek to take reasonable steps to
        ensure that your privacy is protected. By using our Services, you
        understand that your information may be transferred to our systems and
        facilities and those third parties with whom we share it as described in
        this Policy.
        <br />
        <br />
        23. This Policy applies in conjunction with any other notices,
        contractual clauses and consent clauses that apply in relation to the
        collection, use and disclosure of your personal data by us.
        <br />
        <br />
        24. We may from time to time update the Policy without any prior notice
        to you. We may update the Policy to ensure that the Policy is consistent
        with our future developments, industry trends and/or any changes in
        legal or regulatory requirements. Subject to your rights at law, the
        prevailing terms of the Policy shall apply. You may determine if any
        such revision has taken place by referring to the date on which this
        Policy was last updated. Your continued access to and use of our
        Platform and Services constitutes your acknowledgement and acceptance of
        such changes. If you disagree with any part of the Policy, you must
        immediately discontinue your access to, or use of, the Platform and our
        Services.
      </div>

      {/* Footer section */}
      <div
        style={{
          padding: screenWidth > 1200 ? "40px 150px" : "40px 0px",
          display: "flex",
          justifyContent: "space-between",
          textAlign: screenWidth > 1200 ? "left" : "center",
          background: "rgba(0,0,0,0.1)",
          position: "relative",
          zIndex: 200,
        }}
      >
        <div style={{ width: screenWidth > 1200 ? "60%" : "100%" }}>
          <div
            style={{
              width: screenWidth > 1200 ? "40%" : "100%",
              fontWeight: "700",
              fontSize: "35px",
              color: "#256199",
            }}
          >
            SmartLend.
          </div>
          <div style={{ fontWeight: "600", fontSize: "18px" }}>
            Apply Once, Access All.
          </div>
          <div
            style={{
              fontWeight: "300",
              fontSize: "13px",
              width: screenWidth > 1200 ? "100%" : "80%",
              marginLeft: screenWidth > 1200 ? "0%" : "10%",
            }}
          >
            SmartLend Financial Pte. Ltd. Is part of Smart Towkay Brand
          </div>
          <div
            style={{ fontWeight: "600", fontSize: "18px", marginTop: "15px" }}
          >
            Singapore HQ
          </div>
          <div
            style={{
              fontWeight: "400",
              fontSize: "14px",
              marginTop: "3px",
              width: screenWidth > 1200 ? "100%" : "80%",
              marginLeft: screenWidth > 1200 ? "0%" : "10%",
            }}
          >
            114 Lavender St., #07-77 CT Hub 2, Singapore 338729
          </div>
          <div
            style={{ fontWeight: "400", fontSize: "14px", marginTop: "15px" }}
          >
            Folow us and Stay updated
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: screenWidth > 1200 ? "flex-start" : "center",
              marginTop: "15px",
              alignItems: "center",
            }}
          >
            <FacebookIcon
              onClick={() => {
                window.location.href =
                  "https://www.facebook.com/smarttowkaysg/";
              }}
              className="menu_button"
              style={{
                marginRight: "12px",
                color: "rgba(0,0,0,1)",
                cursor: "pointer",
              }}
            />
            <InstagramIcon
              onClick={() => {
                window.location.href =
                  "https://www.instagram.com/smart-towkay/";
              }}
              className="menu_button"
              style={{
                marginRight: "12px",
                color: "rgba(0,0,0,1)",
                cursor: "pointer",
              }}
            />
            {/* <TwitterIcon
              className="menu_button"
              style={{
                marginRight: "12px",
                color: "rgba(0,0,0,1)",
                cursor: "pointer",
              }}
            /> */}
            <img
              className="menu_button"
              src={tiktokIcon}
              onClick={() => {
                window.location.href = "https://www.tiktok.com/@towkaypeople";
              }}
              style={{
                width: 18,
                height: 18,
                objectFit: "cover",
                marginRight: "12px",
              }}
            />
            <img
              className="menu_button"
              src={telegramicon}
              onClick={() => {
                window.location.href = "https://t.me/smarttowkaysg";
              }}
              style={{
                width: 18,
                height: 18,
                objectFit: "cover",
                marginRight: "12px",
              }}
            />
            <img
              className="menu_button"
              src={linkedinicon}
              onClick={() => {
                window.location.href =
                  "https://www.linkedin.com/company/smart-towkay/?originalSubdomain=sg";
              }}
              style={{
                width: 18,
                height: 18,
                objectFit: "cover",
                marginRight: "12px",
              }}
            />
            <img
              className="menu_button"
              src={whatsappicon}
              onClick={() => {
                window.location.href = "https://wa.me/6587853373";
              }}
              style={{
                width: 18,
                height: 18,
                objectFit: "cover",
                marginRight: "12px",
              }}
            />
          </div>
        </div>
        {screenWidth > 1200 ? (
          <div style={{ width: "15%" }}>
            <div style={{ fontWeight: "600", fontSize: "20px" }}>Sitemap</div>
            <div
              style={{
                fontWeight: "300",
                fontSize: "14px",
                marginTop: "15px",
                cursor: "pointer",
              }}
              onClick={() => {
                history.push("/home");
                window.scrollTo(0, 0);
              }}
            >
              Home
            </div>
            <div
              style={{
                fontWeight: "300",
                fontSize: "14px",
                marginTop: "5px",
                cursor: "pointer",
              }}
              onClick={() => {
                history.push("/partner-with-us");
                window.scrollTo(0, 0);
              }}
            >
              Partner With Us
            </div>
            <div
              style={{
                fontWeight: "300",
                fontSize: "14px",
                marginTop: "5px",
                cursor: "pointer",
              }}
              onClick={() => {
                history.push("/frequentlyaskedquestions");
                window.scrollTo(0, 0);
              }}
            >
              Frequently Asked Questions
            </div>
            <div
              style={{
                fontWeight: "300",
                fontSize: "14px",
                marginTop: "5px",
                cursor: "pointer",
              }}
              onClick={() => {
                history.push("/news-events");
                window.scrollTo(0, 0);
              }}
            >
              News & Events
            </div>
            <div
              style={{
                fontWeight: "300",
                fontSize: "14px",
                marginTop: "5px",
                cursor: "pointer",
              }}
              onClick={() => {
                history.push("/contactus");
                window.scrollTo(0, 0);
              }}
            >
              Contact Us
            </div>
          </div>
        ) : null}
      </div>
      <div
        style={{
          background: "rgba(0,0,0,0.85)",
          justifyContent: "center",
          width: "100%",
          display: "flex",
          alignItems: "center",
          padding: "10px 0px",
          position: "relative",
          zIndex: 200,
        }}
      >
        <div
          style={{
            width: screenWidth > 1200 ? "60%" : "80%",
            color: "rgba(256,256,256,.9)",
            fontSize: screenWidth > 1200 ? "14px" : "10px",
            display: "flex",
            justifyContent: "center",
            gap: "10px",
            textAlign: "center",
          }}
        >
          <div
            className="hover_underline"
            style={{ cursor: "pointer" }}
            onClick={() => {
              history.push("/terms-and-conditions");
              window.scrollTo(0, 0);
            }}
          >
            Terms and Conditions
          </div>
          <div style={{ width: "10px" }}>•</div>
          <div>© SmartLend Financial Pte. Ltd.</div>
          <div style={{ width: "10px" }}>•</div>
          <div
            className="hover_underline"
            style={{ cursor: "pointer" }}
            onClick={() => {
              history.push("/privacy-policy");
              window.scrollTo(0, 0);
            }}
          >
            Privacy Policy
          </div>
        </div>
      </div>
    </div>
  );
};
export default PrivacyPolicy;
